import { HttpClient, URL_API } from "../../network";

type TChargeSession = {};

class ChargeSessionServiceApi extends HttpClient {
  getListChargeSession = async (
    params: TParams & {
      charge_point_id?: string;
      by_type?: string;
    },
  ) => {
    const data = await this.instance.get(URL_API.CHARGE_SESSIONS.GET_LIST, {
      params,
    });
    return data;
  };

  getDetailChargeSession = async (idChargeSession: string) => {
    const { data } = await this.instance.get(
      URL_API.CHARGE_SESSIONS.GET_DETAIL + `/${idChargeSession}`,
    );
    return data;
  };

  updateChargeSession = async (dataUpdate: TChargeSession) => {
    const { data } = await this.instance.post(
      URL_API.CHARGE_SESSIONS.UPDATE,
      dataUpdate,
    );
    return data;
  };

  deleteChargeSession = async (idChargeSession: string) => {
    const { data } = await this.instance.post(
      URL_API.CHARGE_SESSIONS.UPDATE + `${idChargeSession}`,
    );
    return data;
  };

  getSettleEnergyChargeSession = async (idChargeSession: string) => {
    const { data } = await this.instance.post(
      URL_API.CHARGE_SESSIONS.GET_SETTLE_ENERGY +
        `${idChargeSession}/settle/energy`,
    );
    return data;
  };

  applySettleEnergyChargeSession = async (dataPayload: any) => {
    const { data } = await this.instance.post(
      URL_API.CHARGE_SESSIONS.GET_SETTLE_ENERGY +
        `${dataPayload?.id}/settle/energy/apply`,
      dataPayload,
    );
    return data;
  };

  flushSession = async (sessionId: string) => {
    const { data } = await this.instance.post(
      `${URL_API.CHARGE_SESSIONS.BASE}/${sessionId}/flush-from-admin`,
      {},
    );
    return data;
  };
}
export const ChargeSessionService = new ChargeSessionServiceApi();
